export default __webpack_public_path__ + "static/36-9be608a8d42afc3aa1efb7ff95ae58a9.jpg";